"use strict";

var _classCallCheck = require("/home/circleci/repo/app/ui-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/circleci/repo/app/ui-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/circleci/repo/app/ui-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/circleci/repo/app/ui-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _get = require("/home/circleci/repo/app/ui-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _inherits = require("/home/circleci/repo/app/ui-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ParseError_1 = require("./errors/ParseError");

var Symbols_1 = require("./Symbols");

var Tokenizer_1 = require("./Tokenizer");

var Directives_1 = require("./enum/Directives");

var ProgramNode_1 = require("./nodes/ProgramNode");

var NodeNames_1 = require("./enum/NodeNames");

var ParserLocation_1 = require("./ParserLocation");

var Nodes_1 = require("./utils/Nodes");

var Parser =
/*#__PURE__*/
function (_ParserLocation_1$Par) {
  _inherits(Parser, _ParserLocation_1$Par);

  function Parser() {
    _classCallCheck(this, Parser);

    return _possibleConstructorReturn(this, _getPrototypeOf(Parser).apply(this, arguments));
  }

  _createClass(Parser, [{
    key: "parse",
    value: function parse(template) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      _get(_getPrototypeOf(Parser.prototype), "parse", this).call(this, template);

      var ast = new ProgramNode_1.default(0, template.length - 1);
      var stack = [];
      var parent = ast;
      var tokens = [];
      options = Object.assign({
        useSquareTags: false,
        parseLocation: true
      }, options);

      if (options.parseLocation) {
        this.addLocation(parent);
      }

      try {
        var tokenizer = new Tokenizer_1.Tokenizer(options);
        tokens = tokenizer.parse(template);

        if (tokens.length === 0) {
          return {
            ast: ast,
            tokens: tokens
          };
        }

        var token = null;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = tokens[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            token = _step.value;
            var tokenType = this.tokenToNodeType(token);

            if (token.isClose) {
              if (token.params) {
                throw new ParseError_1.default("Close tag '".concat(tokenType, "' should not have params"), token);
              }

              if (parent.type !== tokenType) {
                throw new ParseError_1.default("Unexpected close tag '".concat(tokenType, "'"), token);
              }

              parent = stack.pop();

              if (options.parseLocation) {
                this.addLocation(parent);
              }
            } else {
              var node = this.addNodeChild(parent, token);

              if (node !== parent && node.hasBody) {
                if (!this.isPartial(tokenType, parent.type)) {
                  stack.push(parent);
                }

                parent = node;

                if (options.parseLocation) {
                  this.addLocation(parent);
                }
              }
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        if (stack.length > 0) {
          var el = stack.pop();
          throw new ParseError_1.default("Unclosed tag '".concat(el.type, "'"), el);
        }
      } catch (error) {
        if (error instanceof ParseError_1.default) {
          if (options.parseLocation) {
            this.addLocation(error);
          }

          ast.addError(error);
        } else {
          throw error;
        }
      }

      return {
        ast: ast,
        tokens: tokens
      };
    }
  }, {
    key: "addNodeChild",
    value: function addNodeChild(parent, token) {
      var tokenType = this.tokenToNodeType(token);
      var node = Nodes_1.default[tokenType](token, parent);

      if (parent !== node) {
        parent.addToNode(node);
      }

      return node;
    }
  }, {
    key: "isPartial",
    value: function isPartial(type, parentType) {
      switch (type) {
        case NodeNames_1.default.ConditionElse:
          return NodeNames_1.default.Condition === parentType;

        case NodeNames_1.default.Else:
          return NodeNames_1.default.Condition === parentType || NodeNames_1.default.List === parentType;

        case NodeNames_1.default.Recover:
          return NodeNames_1.default.Attempt === parentType;
      }

      return false;
    }
  }, {
    key: "tokenToNodeType",
    value: function tokenToNodeType(token) {
      switch (token.type) {
        case Symbols_1.ENodeType.Directive:
          if (token.text in Directives_1.Directives) {
            return Directives_1.Directives[token.text];
          }

          break;

        case Symbols_1.ENodeType.Interpolation:
          return NodeNames_1.default.Interpolation;

        case Symbols_1.ENodeType.Text:
          return NodeNames_1.default.Text;

        case Symbols_1.ENodeType.Macro:
          return NodeNames_1.default.MacroCall;

        case Symbols_1.ENodeType.Comment:
          return NodeNames_1.default.Comment;
      }

      throw new ParseError_1.default("Unknown token `".concat(token.type, "` - `").concat(token.text, "`"), token);
    }
  }]);

  return Parser;
}(ParserLocation_1.ParserLocation);

exports.Parser = Parser;